import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { Autocomplete, TextField } from '@mui/material';

type AutocompleteInputProps<T extends FieldValues> = {
    readonly id?: string
    control: Control<T>
    readonly name: Path<T>
    readonly type?: string
    readonly className?: string
    readonly options?: { id: string | number, label: string }[]
    readonly label?: string
    readonly defaultValue?: string | number
    readonly value?: string | number
    readonly disabled?: boolean
    readonly hidden?: boolean
    readonly variant?: "standard" | "filled" | "outlined"
    readonly error?: boolean
    readonly helperText?: string
    // readonly ref?: MutableRefObject<any>
    // register: UseFormRegisterReturn;
    // onChange(value: any): any
}

export function AutocompleteInput<T extends FieldValues>(props: Readonly<AutocompleteInputProps<T>>) {
    return (
        <Controller
            name={props.name}
            control={props.control}
            defaultValue={props.defaultValue as T[Path<T>]}
            render={({ field, fieldState }) => (
                <Autocomplete
                    disabled={props.disabled}
                    options={props.options ?? []}
                    getOptionLabel={(option) => option.label}
                    value={props.options?.find(p => p.id === field.value) || null}
                    onChange={(_, value) => {
                        field.onChange(value ? value.id : null);
                    }}
                    renderInput={(params) =>
                        <TextField {...params}
                            label={props.label}
                            error={!!fieldState.error}
                            helperText={fieldState.error?.message}
                        />
                    }
                />
            )}
        />

    );

}
